export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_MARKET = 'en';

export const ROUTE_IDS = Object.freeze({
  CASH_DEPOSIT: 'CASH_DEPOSIT',
});
